import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'bento-ordering/base/components/Snackbar';

const EditSnackbar = ({ open, item, onClose, errorState }) => {
  const getMessage = item => {
    if (errorState) {
      return (
        <span>
          <strong>{item}</strong> could not be updated!
        </span>
      );
    }
    return (
      <span>
        <strong>{item}</strong> was updated in your cart!
      </span>
    );
  };

  return <Snackbar onClose={onClose} open={open} message={getMessage(item)} />;
};

EditSnackbar.defaultProps = {
  open: false,
  errorState: false,
  onClose: () => {}
};

EditSnackbar.propTypes = {
  item: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  errorState: PropTypes.bool
};

export default EditSnackbar;
